import { render } from "./simpleUpload.vue?vue&type=template&id=1847add4"
import script from "./simpleUpload.vue?vue&type=script&lang=js"
export * from "./simpleUpload.vue?vue&type=script&lang=js"

import "./simpleUpload.vue?vue&type=style&index=0&id=1847add4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__